module.exports = __webpack_public_path__ + "static/media/index-popup-big-cattle.a8518ac7.gif";